import { useSite } from "../lib/SiteContext";
import Seo from "../components/Seo";
import FadeIn from "../components/FadeIn";

const DEFAULT_PRIVACY = `Last updated: [DATE TO COMPLETE]

Aloha Corfu Tours ("we", "us") respects your privacy. This policy explains what information we collect through this website and how we use it.

1. Who we are
Aloha Corfu Tours is a private tours business based in Corfu, Greece. You can contact us at infoalohatransfers@gmail.com or on WhatsApp at +30 698 340 0353. [BUSINESS ADDRESS TO COMPLETE BEFORE PUBLICATION]

2. What we collect
When you send us a tour enquiry or contact message, we collect the details you provide: your name, email address, telephone/WhatsApp number, preferred tour dates, group size, meeting point and any special requests you write.

3. How we use it
We use this information only to answer your enquiry, plan and confirm your tour, and communicate with you about it. We do not sell your data and we do not use it for marketing without your consent.

4. How long we keep it
Enquiry details are kept only as long as needed to handle your request and manage our bookings. You can ask us to delete your details at any time.

5. Sharing
We do not share your personal details with third parties, except the technical services needed to operate this website and deliver our emails (website hosting and email delivery providers).

6. Your rights
Under the GDPR you have the right to access, correct or delete your personal data, and to object to its use. To exercise any of these rights, email infoalohatransfers@gmail.com.

7. Cookies & analytics
This website may use privacy-friendly analytics to understand how visitors use the site. [CONFIRM ANALYTICS/COOKIE SETUP BEFORE PUBLICATION]

8. Changes
We may update this policy from time to time. The latest version is always on this page.

[THIS IS AN EDITABLE TEMPLATE — the business owner should review and complete the marked fields before publication. It is not legal advice.]`;

const Privacy = () => {
  const { content } = useSite();
  const text = content?.privacy_text?.trim() ? content.privacy_text : DEFAULT_PRIVACY;

  return (
    <div data-testid="privacy-page">
      <Seo
        title="Privacy Policy — Aloha Corfu Tours"
        description="How Aloha Corfu Tours collects, uses and protects your personal information when you send a tour enquiry or contact us."
      />
      <section className="bg-pine-dark py-14 md:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <FadeIn>
            <h1 className="font-display text-4xl font-semibold text-white sm:text-5xl">Privacy Policy</h1>
          </FadeIn>
        </div>
      </section>
      <section className="py-12 md:py-16">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8" data-testid="privacy-content">
          {text.split("\n\n").map((block, i) => {
            const lines = block.split("\n");
            if (lines.length > 1 && /^\d+\./.test(lines[0])) {
              return (
                <FadeIn key={i} className="mb-6">
                  <h2 className="font-display text-xl font-semibold text-pine">{lines[0]}</h2>
                  <p className="mt-2 text-sm leading-relaxed text-gray-600">{lines.slice(1).join(" ")}</p>
                </FadeIn>
              );
            }
            return <FadeIn key={i} className="mb-4 text-sm leading-relaxed text-gray-600"><p>{block}</p></FadeIn>;
          })}
        </div>
      </section>
    </div>
  );
};

export default Privacy;
